import {VerifiedHTMLText} from '@github-ui/safe-html/VerifiedHTML'
import stickyStyles from '@github-ui/use-sticky-header/use-sticky-header.module.css'
import {useStickyHeader} from '@github-ui/use-sticky-header/useStickyHeader'
import {clsx} from 'clsx'
import {RelativeTime} from '@primer/react'
import {PullRequestState} from '../types'
import type {ReactNode} from 'react'
import type {PullRequest} from '../types'
import styles from './PullRequestMiniHeader.module.css'
import {StateIcon} from './StateIcon'
import {useHydrateMarkerCounts} from '../hooks/use-hydrate-marker-counts'

function getStatusObj(state: PullRequestState) {
  switch (state) {
    case PullRequestState.Merged:
      return {text: 'merged', datetimeKey: 'mergedTime' as const}
    case PullRequestState.Closed:
      return {text: 'closed', datetimeKey: 'closedTime' as const}
    default:
      return {text: 'opened', datetimeKey: 'createdTime' as const}
  }
}

export interface PullRequestMiniHeaderProps {
  pullRequest: PullRequest
  children?: ReactNode
}

export function PullRequestMiniHeader({pullRequest, children}: PullRequestMiniHeaderProps) {
  const {isSticky, sensorRef} = useStickyHeader()
  useHydrateMarkerCounts()

  const {text: statusText, datetimeKey} = getStatusObj(pullRequest.state)
  const datetime = pullRequest[datetimeKey]

  return (
    <>
      <div className={clsx(stickyStyles.stickyHeader, styles.miniHeader, isSticky && styles['is-stuck'])}>
        <StateIcon state={pullRequest.state} />
        <span className={clsx(styles.number, 'f5 fgColor-muted')}>#{pullRequest.number}</span>
        {isSticky && (
          <span className={clsx(styles.title, 'f5 text-bold fgColor-default')}>
            <VerifiedHTMLText className="markdown-title" html={pullRequest.titleHtml} />
          </span>
        )}
        {!isSticky && datetime && (
          <span className="f5 fgColor-muted">
            {statusText} <RelativeTime datetime={datetime} />
          </span>
        )}
        {children != null && <div className={styles.actions}>{children}</div>}
      </div>
      <div ref={sensorRef} className={styles.stickyHeaderSentinel} />
    </>
  )
}
